module.exports = __webpack_public_path__ + "img/money-euro-circle-line.d2678271.svg";